import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { FormControl, FormLabel, HStack, Select } from '@tq/ui-components';

import { SearchText } from 'components';
import { manageTeamOrganisationFilterState, manageTeamSearchState } from 'store';
import { useGetManageTeamRecords } from '../../../hooks';
import { useAllParentOrganisations } from 'api';
import { filterFormControlStyle, filterSelectStyle } from 'styles';
import { filterContainerStyle } from '../../../styles';

export const TeamFilters: React.FC = () => {
  const { t } = useTranslation('manage_consultees');
  const { data, totalCount } = useGetManageTeamRecords();
  const { data: parentOrganisations } = useAllParentOrganisations();
  const [organisationFilter, setOrganisationFilter] = useRecoilState(
    manageTeamOrganisationFilterState
  );
  const organisations = parentOrganisations?.parentOrganisations ?? [];

  const handleOrganisationChange = (selectedId: number) => {
    let orgName = '';
    const selectedOrg = organisations.find((org) => org.value === selectedId);

    if (selectedOrg) orgName = selectedOrg.label;
    setOrganisationFilter(orgName);
  };

  return (
    <HStack id='team-filter' sx={filterContainerStyle} alignItems='baseline'>
      <FormControl flex='1 1 100%'>
        <FormLabel display={{ base: 'none', lg: 'block' }}>
          {t('search_label', 'Search')}:
        </FormLabel>
        <SearchText
          searchState={manageTeamSearchState}
          placeholderText={t('search_placeholder', 'Search by name or email')}
          recordCount={data.length}
          totalCount={totalCount}
        />
      </FormControl>
      <FormControl
        mx={{ base: 0, lg: '1.25rem' }}
        my={{ base: '1rem', lg: 0 }}
        sx={filterFormControlStyle}
      >
        <FormLabel htmlFor='team' mb={{ base: 0, lg: '.75rem' }}>
          {t('organisation_label', 'Organisation')}:
        </FormLabel>
        <Select
          inputId='team'
          onChange={(value) => handleOrganisationChange(Number(value))}
          defaultValue={organisationFilter.toString()}
          sx={filterSelectStyle}
          aria-label='Organisation selection dropdown'
        >
          <option key='all' value={0}>
            {t('all', 'All')}
          </option>
          {organisations?.map((org) => (
            <option key={org.value} value={org.value}>
              {org.label}
            </option>
          ))}
        </Select>
      </FormControl>
    </HStack>
  );
};
